import { render } from "./SubpageLayout.vue?vue&type=template&id=5f2a918c"
import script from "./SubpageLayout.vue?vue&type=script&lang=js"
export * from "./SubpageLayout.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./SubpageLayout.vue?vue&type=style&index=0&id=5f2a918c&module=true&lang=css"
cssModules["$style"] = style0
script.render = render

export default script